<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование FAQ группы" : "Добавление FAQ группы"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          s-publish-date-status(
            :errors='errors'
            :model='model'
            label='Опубликовано'
          )
        v-flex(xs4)
          v-text-field(
            :error='errors.has("id")'
            :error-messages='errors.first("id")'
            v-model='model.id'
            label='ID группы на латинице'
            :readonly="!!this.id"
          )
        v-flex(xs4)
            v-checkbox(
              v-model='model.show_on_faq_page'
              label='Выводить на странице FAQ'
              color='primary'
            )          
        v-flex(xs12)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='model.name'
            label='Название группы'
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("annotation")'
            :error-messages='errors.first("annotation")'
            v-model='model.annotation'
            label='Краткое описание'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  data: () => ({
    model: {}
  }),

  async created() {
    if (!this.id) return
    this.updateItem()
  },

  methods: {
    async updateItem() {
      const response = await this.fetchSingle({ id: this.id.toString() })
      this.model = response.data
    },

    async onSave() {
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data: this.model
          })
        } else {
          await this.create({
            data: this.model
          })
        }

        this.$root.showSnack('Сохранено')
        this.$router.push({ name: 'Seo.FaqGroups' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    ...mapActions('seo/faqGroups', [
      'fetchSingle',
      'update',
      'create'
    ])
  },

  computed: {
    ...mapGetters('seo/faqGroups', ['isLoading'])
  }
}
</script>

<style scoped>
.small textarea {
  font-size: 12px;
}
</style>
